import Vue from 'vue';
import { getMemberList, getMemberLevelList } from '../../../services/personnelService/contactsService';

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
  memberList: [],
  cardTypeOptions: [],
  memberLevelList: []
};

// getters
const getters = {};

// actions
const actions = {
  // 取得顧問 Profile
  async getMemberListHandler({ commit }, paginationInfo) {
    const data = await getMemberList(paginationInfo);
    commit('setMemberList', data);
  },
  // 取得會員等級
  async getMemberLevelListHandler({ commit }) {
    const data = await getMemberLevelList();
    commit('setMemberLevelList', data.data);
  },
};

// mutations
const mutations = {
  setMemberList(state, data) {
    Vue.set(state, 'memberList', data.data.members);
  },
  resetHandler(state) {
    Vue.set(state, 'memberList', []);
    Vue.set(state, 'cardTypeOptions', []);
    Vue.set(state, 'memberLevelList', []);
  },
  setMemberLevelList(state, data) {
    Vue.set(state, 'memberLevelList', data.level);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
